/**
 * Map Service Singleton
 *
 * Provides a configured instance of the current map provider.
 * This abstraction allows easy swapping of map providers by changing only this file.
 *
 * Current provider: Geoapify with MapLibre GL JS
 *
 * @module map_service
 */

import { GeoapifyMapService } from '@/services/geoapify_map_service';
import type { MapProvider } from '@/types/map_provider';

/**
 * Singleton instance of the map service.
 * Use this throughout the application for all map operations.
 *
 * @example
 * import { mapService } from '@/services/map_service';
 *
 * await mapService.load();
 * const map = await mapService.createMap(element, options);
 */
export const mapService: MapProvider = new GeoapifyMapService();
